/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/cable-car-1216071': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M19 6.5h-6V4h4.62a1 1 0 000-2H6.38a1 1 0 100 2H11v2.5H5a3 3 0 00-3 3V19a3 3 0 003 3h14a3 3 0 003-3V9.5a3 3 0 00-3-3zM11 20H5a1 1 0 01-1-1v-3.75h7a.5.5 0 000 .13v4.5a.53.53 0 000 .12zm9-1a1 1 0 01-1 1h-6a.53.53 0 000-.12v-4.5a.5.5 0 000-.13h7zm0-5.75H4V9.5a1 1 0 011-1h14a1 1 0 011 1z"/>'
  }
})
